module.exports = __webpack_public_path__ + "img/salad-waist-measure.8f6eed6f.jpg";